import FeatureFlags from 'core/featureFlags';
import { getAccessToken } from 'views/utils/lux-util';

const getPrimaryRoutes = () => {
  const routes = ['dashboards'];

  const decoded = getAccessToken();

  if (decoded?.migrated === 'false') {
    routes.unshift('survey-management');
  }

  if (FeatureFlags.hasFeature('datasources-list')) {
    routes.splice(3, 0, 'datasources');
  }

  return routes;
};

export default getPrimaryRoutes;
